import React, { useState, useEffect, useContext } from "react";
import PaymentServiceAPI from "../../Services/PaymentServiceApi";
import OrchestrationServiceApi from "../../Services/OrchestrationService";
import $ from "jquery";
import UserDataContext from "../../Contexts/User.context";
import { useNavigate, useSearchParams } from "react-router-dom";
import PathHelper from "../../Util/PathHelper";
import { APP_NAVIGATION } from "../../Util/Constants";
import { EMPTY_GUID } from "../../Config/Constants";
import { getPortalCD, readCookie, setIPConfig } from "../../Util/helper";
import { defaultCountryCode, defaultCurrencyCode, getTenantId } from "../../Util/general-config";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import BillingDataContext from "../../Contexts/Billing.Context";
import { billingActionEnum } from "../../Config/BillingType";
import PaymentFailedModal from "../../Components/Shared/PaymentFailedModal/PaymentFailedModal";
import DocBuilderService from "../../Services/DocBuilderService";

type Props = {
	fieldValues: any;
	callbackErrorMessage: any;
	doCheckOut: any;
	handleLoaderPopupHide: Function;
	queryParams: any;
};

declare global {
	interface Window {
		$: JQueryStatic;
		jQuery: JQueryStatic;
	}
}
declare global {
	interface Window {
		reactFunction: () => void;
	}
}
const CheckoutArticleBoxRight = ({
	fieldValues,
	callbackErrorMessage,
	doCheckOut,
	handleLoaderPopupHide,
	queryParams,
}: Props) => {
	window.$ = $;
	window.jQuery = $;
	const { state, dispatch } = useContext(BillingDataContext);
	//let queryParams = new URLSearchParams(window.location.search);
	const [searchParams] = useSearchParams();
	const qsGateWayId = searchParams.get("gatewayid");
	// const [showLoader, setShowLoader] = useState("d-none");
	const [skuGuidDetails, setSkuGuidDetails] = useState<any>();
	const [recurringPrice, setRecurringPrice] = useState("");
	const [unitPrice, setUnitPrice] = useState("");
	const [showModal, setShowModal] = useState(false);
	const [estimateTax, setEstimateTax] = useState("");
	const [subTotal, setSubTotal] = useState("");
	const [hideTaxEstimate, setHideTaxEstimate] = useState(true);
	const navigate = useNavigate();
	let pathRedirect = PathHelper(APP_NAVIGATION.CHPG);
	let isLoaded: any = !!readCookie("isLoaded") ? readCookie("isLoaded") : "false";
	const skuDetails = () => {
		handleLoaderPopupHide("d-block");
		let skuId = queryParams.get("s") || "";
		PaymentServiceAPI.getSkuDetails(skuId, "en").then((response: any) => {
			dispatch({
				type: billingActionEnum.SKU_DETAILS,
				payload: {
					skuGuid: response.id,
					skuSubCategory: response.skuSubCategory,
					unitPrice: response.unitPrice,
					recurringPrice: response.recurringPrice,
					scheduleTypeCD: response.scheduleTypeCD,
					currencyCD: response.currencyCD,
					currencySymbol: response.currencySymbol,
					description: response.description,
					label: response.label,
				},
			});
			setRecurringPrice(response.currencySymbol + parseFloat(response.recurringPrice.toString()).toFixed(2));
			setUnitPrice(response.currencySymbol + parseFloat(response.unitPrice.toString()).toFixed(2));
			setSkuGuidDetails(response);
			setEstimateSaleTax(response);
		});
	};

	useEffect(() => {
		if (!!readCookie("jwtToken")) {
			skuDetails();
		}
	}, []);
	const {
		state: { userGUID, email },
	} = useContext(UserDataContext);

	const paymentRequstData = (
		tokenxToken: any,
		cardType: any,
		transactionId: any,
		gatewayId: any,
		users: any,
		outCome: any,
		omniScore: any,
		kountResponse: any,
		fullName: any,
		ExpMonth: any,
		ExpYear: any
	) => {
		const name = fullName.replace(/[^a-zA-Z ]/g, "").split(" ");
		let fname = name[0];

		let lname = name.length > 1 ? fullName.substring(fullName.indexOf(" ") + 1) : "";
		let customFieldsData = {
			ipcountry: setIPConfig("countryCode", defaultCountryCode),
			protalsrc: getPortalCD(),
			localeval: "en",
		};
		let paymentRquestObject = {
			firstName: fname,
			lastName: lname,
			email: email,
			paymentPortal: getPortalCD(),
			skuGuid: queryParams.get("s"),
			userGuid: userGUID,
			visitid: readCookie("visitGuid"),
			visitorid: readCookie("visitorGuid"),
			portalSource: getPortalCD(),
			customFields: customFieldsData,
			customerSource: "",
			paypalToken: "",
			ipAddress: setIPConfig("query"),
			gatewayID: !!qsGateWayId ? qsGateWayId : gatewayId,
			currency: "USD", //skuGuidDetails.currencyCD,
			customerId: "",
			ccDetails: {
				cardType: cardType, //document.getElementById("hdnCardType").value,
				token: tokenxToken, //document.getElementById("tokenExToken").value,
				ccExpiryMonth: ExpMonth,
				ccExpiryYear: ExpYear,
				cvv: "0",
			},
			transactionId: transactionId || EMPTY_GUID,
			users: users,
			docCount: 0,
			score: 0,
			outCome: outCome,
			omniScore: omniScore,
			kountResponse: kountResponse,
			subTotal: subTotal != "" ? subTotal.toString() : "",
			estimatedTax: estimateTax != "" ? estimateTax.toString() : "",
			userAddress: getUserAddressObject(),
		};
		return paymentRquestObject;
	};

	const getUserAddressObject = () => {
		var userAddressObject = {
			userGuid: userGUID,
			city: setIPConfig("city"),
			state: setIPConfig("region"),
			country: setIPConfig("country"),
			zipCode: setIPConfig("zip"),
			addressType: 1,
			isActive: true,
			tenantId: getTenantId(),
		};
		return userAddressObject;
	};
	const setEstimateSaleTax = (response: any) => {
		const stateCode = setIPConfig("region"); //"IL";
		const zipCode = setIPConfig("zip"); //"60630"; //
		const planAmount = response.scheduleTypeCD === "YEAR" ? response.recurringPrice : response.unitPrice;
		PaymentServiceAPI.getTaxEstimate(stateCode, zipCode, planAmount)
			.then((response: any) => {
				if (!!response) {
					setHideTaxEstimate(true);
					setEstimateTax(response.estimatedTax);
					setSubTotal(response.subTotal);
					handleLoaderPopupHide("d-none");
				} else {
					if (queryParams.has("pplrtrn") && queryParams.has("token") && isLoaded === "true") {
						handleLoaderPopupHide("d-block");
					} else {
						handleLoaderPopupHide("d-none");
					}
					setHideTaxEstimate(false);
				}
			})

			.catch((error) => {
				handleLoaderPopupHide("d-none");
				console.log("Error");
			});
	};

	const PaymentFailureResponse = () => {
		setShowModal(true);

		//handleLoaderPopupHide("d-none");
		// //setIsShowError("d-block");
		// callbackErrorMessage("PAYMENT DECLINED: please try again with different card or recheck the credentials.")
	};
	const paymentSuccessResponse = () => {
		navigate(pathRedirect.next + "?s=" + skuGuidDetails.id);
	};

	const LogPaymentSuccessEvent = () => {
		// try {
		//   window.TrackAmplitudeEvent("payment_success");
		//   window.TrackMixPanelEvent("payment_success");
		// } catch {}
		// let eventData = {
		//   Id: CreateUUID(),
		//   UserId: uGuid,
		//   VisitorId: readCookie("visitorGuid"),
		//   VisitId: readCookie("visitGuid"),
		// };
		// eventServicePostConnect(eventData).then((response) => {
		//   if (!!response) {
		paymentSuccessResponse();
		//   } else {
		//     PaymentFailureResponse();
		//   }
		// });
	};

	const processNormalPayment = (
		tokenxToken: any,
		cardType: any,
		gatewayId: any,
		outCome: any,
		omniScore: any,
		kountResponse: any,
		fullName: any,
		ExpMonth: any,
		ExpYear: any
	) => {
		const users = null;
		var tobeProcessDataForPayment = paymentRequstData(
			tokenxToken,
			cardType,
			null,
			gatewayId,
			users,
			outCome,
			omniScore,
			kountResponse,
			fullName,
			ExpMonth,
			ExpYear
		);
		doCheckOut(tobeProcessDataForPayment);
		// OrchestrationServiceApi.checkoutProcess(tobeProcessDataForPayment)
		//   .then((response: any) => {
		//     dispatch({
		//       type: billingActionEnum.CONFIRMATION,
		//       payload: { orderId: response },
		//     });
		//     if (response === 0) {
		//       callbackErrorMessage("PAYMENT DECLINED: please try again with different card or recheck the credentials.");
		//     }
		//     if (!!response) {
		//       const docid = readCookie("docid");
		//       if (docid) {
		//         console.log("generate pdf before process ..");
		//         DocBuilderService.GeneratePDFPath(docid, userGUID).then((docResponse: any) => {
		//           console.log(docResponse);
		//           // TO DO :: generate path before navigation
		//           setShowLoader("d-none");
		//           navigate(pathRedirect.next);
		//           LogPaymentSuccessEvent();
		//         });
		//       } else {
		//         console.log("navigation with out path generate ..");
		//         // default  flow without path generate
		//         setShowLoader("d-none");
		//         navigate(pathRedirect.next);
		//         LogPaymentSuccessEvent();
		//       }
		//     } else {
		//       setShowLoader("d-none");
		//       PaymentFailureResponse();
		//     }
		//   })
		//   .catch((err: any) => {
		//     setShowLoader("d-none");
		//     PaymentFailureResponse();
		//   });
	};
	const process3DSPayment = (
		tokenxToken: any,
		cardType: any,
		gatewayId: any,
		outCome: any,
		omniScore: any,
		kountResponse: any
	) => {
		// var cbInstance = window.Chargebee.init({
		//   site: getChargBeeSiteName(),
		//   publishableKey: getChargBeeUserName(),
		// });
		// var ccDt = new CCDt();
		// ccDt.t = tokenxToken;
		// ccDt.n = fullName;
		// ccDt.em = ExpMonth;
		// ccDt.ey = ExpYear;
		// ccDt.cv = "";
		// cbInstance
		//   .load("components")
		//   .then(() => {
		//     cbInstance
		//       .load3DSHandler()
		//       .then((threeDSHandler:any) => {
		//         window.threeDS = threeDSHandler;
		//         const users = null;
		//         var data = paymentRequstData(
		//           tokenxToken,
		//           cardType,
		//           null,
		//           gatewayId,
		//           users,
		//           outCome,
		//           omniScore,
		//           kountResponse
		//         );
		//         data.gatewayID = getGateWayIdfor3DSCheckout();
		//         CreatePaymentIntentConnect(data).then((response) => {
		//           const { customerId, paymentIntent, transactionId } = response || {};
		//           if (!!customerId) {
		//             // window.threeDS.setPaymentIntent(JSON.parse(response.paymentIntent));
		//             window.threeDS.setPaymentIntent(JSON.parse(paymentIntent));
		//             window.threeDS
		//               .handleCardPayment()
		//               .then((paymentIntent) => {
		//                 var tobeProcessDataForPayment = paymentRequstData(
		//                   score,
		//                   tokenxToken,
		//                   cardType,
		//                   transactionId,
		//                   null,
		//                   users,
		//                   outCome,
		//                   omniScore,
		//                   kountResponse
		//                 );
		//                 tobeProcessDataForPayment.customerId = response.customerId;
		//                 paymentProcess3DSConnect(tobeProcessDataForPayment).then((response) => {
		//                   if (!!response) {
		//                     LogPaymentSuccessEvent();
		//                   } else {
		//                     PaymentFailureResponse();
		//                   }
		//                 });
		//               })
		//               .catch((err:any) => {
		//                 PaymentFailureResponse();
		//               });
		//           } else {
		//             PaymentFailureResponse();
		//             //processNormalPayment(tokenxToken, cardType);
		//           }
		//         });
		//       })
		//       .catch((err:any) => {
		//         PaymentFailureResponse();
		//       });
		//   })
		//   .catch((err: any) => {
		//     PaymentFailureResponse();
		//   });
	};

	const InitiatePaymentProcess = (
		tokenxToken: any,
		cardType: any,
		isBadBin: any,
		gatewayId: any,
		outCome: any,
		omniScore: any,
		kountResponse: any,
		fullName: any,
		ExpMonth: any,
		ExpYear: any
	) => {
		//Step 1 - Check BadBins
		//Step 2 - If Exist than chargbee create PaymentIntent call
		//Step 2.1 - If not than normal payment
		//Step 3 - If Create Payment Intent Call success then checkout 3 ds call
		//Step 4 - in case error show err

		//const gatewayId = getGateway(caseIndex);\
		// if (isBadBin) {
		//   process3DSPayment(tokenxToken, cardType, "", outCome, omniScore, kountResponse);
		// } else {
		processNormalPayment(
			tokenxToken,
			cardType,
			gatewayId,
			outCome,
			omniScore,
			kountResponse,
			fullName,
			ExpMonth,
			ExpYear
		);
		//}

		// .catch((err) => {
		//   processNormalPayment(tokenxToken, cardType);
		// });
	};
	const onPaymentClickHandler = () => {
		//setShowLoader("d-block");
		console.log(fieldValues);
		window.reactFunction = () => {
			handleLoaderPopupHide("d-block");
			const { name, expmo, expyr } = fieldValues;
			var tokenExValue = (document.getElementById("tokenExToken") as HTMLInputElement).value;
			var cardTypeValue = (document.getElementById("hdnCardType") as HTMLInputElement).value;
			var outCome = (document.getElementById("hdnOutCome") as HTMLInputElement).value;
			var omniScore = (document.getElementById("hdnOmniScore") as HTMLInputElement).value;
			var kountResponse = (document.getElementById("hdnKountResponse") as HTMLInputElement).value;

			// var fullName = (document.getElementById("checkout_form_card_name") as HTMLInputElement).value;
			// var ExpMonth = (document.getElementById("expmo") as HTMLInputElement).value;
			// var ExpYear = (document.getElementById("expyr") as HTMLInputElement).value;

			let isBadBin = false;
			PaymentServiceAPI.isCardInBadBins(tokenExValue.slice(0, 6)).then((response: any) => {
				isBadBin = response;
				InitiatePaymentProcess(
					tokenExValue,
					cardTypeValue,
					isBadBin,
					"",
					outCome,
					omniScore,
					kountResponse,
					name,
					expmo,
					expyr
				);
			});
		};
	};

	return (
		<>
			<div className={hideTaxEstimate ? "pdfOrderReviewWrap hidetaxestimate" : "pdfOrderReviewWrap"}>
				<div className="pdfOrderReviewHeader">
					{/* <h3>Review order</h3> */}
					<h3>Review Your Order and Get Your Document</h3>
					<p className="pdfFullAccess">{!!skuGuidDetails?.unitPrice ? skuGuidDetails?.label : ""}</p>
				</div>
				<div className="pdfPaymentList">
					<ul>
						<li>
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/Edits.svg"} />
							</span>
							<span className="pdfPaymentText">100+ Legal Forms and Templates to Choose From </span>
						</li>
						<li>
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/Edits.svg"} />
							</span>
							<span className="pdfPaymentText">Pre-written Legal Samples and easy-to-use Builder </span>
						</li>
						<li>
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/Downloads.svg"} />
							</span>
							<span className="pdfPaymentText">Unlimited Downloads and Edits</span>
						</li>
						<li>
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/Convert.svg"} />
							</span>
							<span className="pdfPaymentText">
								Convert to Any Format
								{/* <br /> */}
								(word, .docx, .doc, jpg, excel){" "}
							</span>
						</li>
						{/* <li className="flex">
              <span className="pdfPaymentIcon">
                <img src={process.env.PUBLIC_URL + "/static/images/Members.svg"} />
              </span>
              <span className="pdfPaymentText">{skuGuidDetails?.scheduleTypeCD === "YEAR" ?"Share with 7 Other Users":"Share with 5 Family Members & Friends"}</span>
            </li> */}
						<li className="flex">
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/send-for-esign.svg"} />
							</span>
							<span className="pdfPaymentText">Add and Request Electronic Signatures in Seconds</span>
						</li>
						<li className="flex">
							<span className="pdfPaymentIcon">
								<img src={process.env.PUBLIC_URL + "/static/images/Members.svg"} />
							</span>
							<span className="pdfPaymentText">Print, Download & Share your Legal Documents</span>
						</li>
					</ul>
				</div>

				{hideTaxEstimate ? (
					<>
						<div className="pdfReviewOrderPriceWrap subtotal">
							<span>
								<b>Subtotal:</b>
							</span>
							<span className="pdfReviewOrderPrice">
								<b> {subTotal}</b>
							</span>
						</div>
						<div className="pdfReviewOrderPriceWrapAvlara">
							<span>
								<b>Estimate Sale Tax:</b>
							</span>
							<span className="pdfReviewOrderPrice">
								<b> {estimateTax}</b>
							</span>
						</div>
					</>
				) : (
					""
				)}

				<div className="pdfReviewOrderBTNWrap">
					<div className="pdfReviewOrderPriceWrap">
						<span>Total Due Today</span>
						<span className="pdfReviewOrderPrice">
							{skuGuidDetails?.scheduleTypeCD === "YEAR" ? recurringPrice : unitPrice}
						</span>
					</div>
					<div className="pdfReviewOrderBTN fbn bounce-effect">
						<a className="pdfBtnRO" href="javascript://" id="btnChargeebeeSubmit" onClick={onPaymentClickHandler}>
							Download My Document
						</a>
					</div>
				</div>
			</div>
			{showModal && <PaymentFailedModal show={showModal} onHide={() => setShowModal(false)} />}
		</>
	);
};
export default CheckoutArticleBoxRight;
